import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import debounce from 'lodash/debounce';
import { ReactElement } from 'react';
import { useForm } from 'react-hook-form';
import { ValueType } from 'react-select';

import { useStoreActions, useStoreState } from '~/store/hooks';
import Input from '~/ui/components/inputs/Input';
import { IOption, IsMulti } from '~/ui/components/inputs/Select/types';
import SelectComponent from '~/ui/components/inputs/SelectWithoutAnimation/SelectWithoutAnimation';
import ResourceType from '~/ui/pages/Resources/models/ResourceType';

import { DEBOUNCE_TIME_500 } from '~/ui/constants/common';
import resourceTypeOptions from '~/ui/pages/Resources/constants/resourceTypeOptions';

import variables from '~/ui/assets/styles/colors.module.scss';
import styles from './ResourcesFilters.module.scss';

const ResourcesFilters = (): ReactElement => {
  const { filters } = useStoreState(action => action.resource);

  const { setResourcesFilters } = useStoreActions(action => action.resource);

  const {
    control,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: { name: filters.name, type: filters.type },
  });

  const handleNameChange = debounce((value: string) => {
    setResourcesFilters({ name: value, type: filters.type });
  }, DEBOUNCE_TIME_500);

  const handleTypeChange = (option: ValueType<IOption | IOption[], IsMulti>) => {
    setResourcesFilters({ name: filters.name, type: (option as IOption).value as ResourceType });
  };

  return (
    <div className={styles.resourcesFilters}>
      <form>
        <Grid container spacing={1}>
          <Grid
            size={{
              sm: 4,
            }}
          >
            <Input
              register={register}
              placeholder="Search resource"
              name="name"
              errors={errors}
              startAdornment={<SearchIcon color="primary" />}
              onChangeCallback={handleNameChange}
            />
          </Grid>
          <Grid
            className={styles.selectContainer}
            size={{
              sm: 2,
            }}
          >
            <SelectComponent
              label="Filter By File Type"
              control={control}
              name="type"
              errors={errors}
              options={resourceTypeOptions}
              hideSelectedOptions={false}
              placeholder="All"
              color={variables.colorRed}
              onSelect={handleTypeChange}
            />
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
export default ResourcesFilters;
